<template>
    <div>
        <el-form :model="shopProduct" ref="shopProductForm" :rules="rules" label-width="80px" size="mini" :inline="true">
            <el-form-item label="商品名称" prop="productName">
                <el-input style="width: 200px" size="small" v-model="shopProduct.productName"></el-input>
            </el-form-item>
            <el-form-item label="商品货号" prop="productNumber">
                <el-input style="width: 130px" size="small" v-model="shopProduct.productNumber"></el-input>
                <el-button type="primary" @click="genProductNum" size="small" style="margin-left: 10px; width: 60px">生成</el-button>
            </el-form-item>
            <el-form-item label="所属店铺" prop="shopId" v-if="showShop">
                <GridSelectShop
                    style="width: 200px"
                    title="选择店铺"
                    labelName="shopName"
                    labelValue="id"
                    :value="shopProduct.shopId"
                    :limit="1"
                    size="small"
                    @getValue="getValueShopId"
                    :columns="SHOP_code"
                    :searchs="SHOP_search"
                    dataListUrl="/mall/shop/findList"
                    entityBeanName="mallShop"
                    queryEntityUrl="/mall/shop/get"
                >
                </GridSelectShop>
            </el-form-item>

            <el-form-item label="商品价格" prop="shopPrice" placeholder="请输入商品的商品价格" v-if="saleMode == 1 || saleMode == 3 || (saleModeTwo == 0 && (saleMode == '' || saleMode == 2))">
                <el-input style="width: 200px" size="small" v-model="shopProduct.shopPrice"></el-input>
            </el-form-item>
            <el-form-item label="供货价格" prop="supplyPrice" placeholder="请输入商品的供货价格" v-if="saleMode == 2">
                <el-input style="width: 200px" size="small" v-model="shopProduct.supplyPrice"></el-input>
            </el-form-item>
            <el-form-item label="批发价格" prop="wholesalePrice" placeholder="请输入商品的批发价格" v-if="saleMode == 3">
                <el-input style="width: 200px" size="small" v-model="shopProduct.wholesalePrice"></el-input>
            </el-form-item>
            <el-form-item label="起批数量" prop="buyMinLimit" placeholder="请输入商品的起批数量" v-if="saleMode == 3 && !isItWholesale">
                <el-input style="width: 200px" size="small" v-model="shopProduct.buyMinLimit"></el-input>
            </el-form-item>
            <el-form-item label="市场价格" prop="marketPrice" placeholder="请输入商品的市场价格">
                <el-input style="width: 200px" size="small" v-model="shopProduct.marketPrice"></el-input>
            </el-form-item>

            <el-form-item label="成本价格" prop="costPrice" placeholder="请输入商品的成本价格">
                <el-input style="width: 200px" size="small" v-model="shopProduct.costPrice"></el-input>
            </el-form-item>
			
			<!--el-form-item label="推荐手机" prop="inviterMobile">
			    <el-input style="width: 200px" placeholder="请输入商品推荐人手机" size="small" v-model="shopProduct.inviterMobile"></el-input>
			</el-form-item-->
			
			<el-form-item label="商品类目" prop="categoryId">
			    <el-select style="width: 200px" v-model="shopProduct.categoryId" placeholder="请选择" clearable size="small">
			        <el-tree node-key="id" :default-expanded-keys="expands" :data="shopProductCategoryList" :props="treeProps">
			            <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
			                <el-option :label="node.label" :value="data.id"> </el-option>
			            </div>
			        </el-tree>
			    </el-select>
			</el-form-item>

            <el-form-item label="商品分类" prop="shopCategoryId" v-if="(showMode == 1 && showShop == 0) || showShop == 1">
                <el-select style="width: 200px" :disabled="!shopProduct.shopId && showShop != 0" v-model="shopProduct.shopCategoryId" placeholder="请选择" clearable size="small">
                    <el-tree node-key="id" :default-expanded-keys="expandss" :data="shopCategoryIds" :props="treeProps">
                        <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                            <el-option :label="node.label" :value="data.id"> </el-option>
                        </div>
                    </el-tree>
                </el-select>
            </el-form-item>
			
            <el-form-item label="商品品牌" prop="brandId">
                <GridSelect
                    style="width: 200px"
                    title="选择品牌"
                    labelName="brandName"
                    labelValue="id"
                    :value="shopProduct.brandId"
                    :limit="1"
                    size="small"
                    placeholder="请选择品牌"
                    @getValue="getValue"
                    :columns="BRAND_code"
                    :searchs="BRAND_search"
                    dataListUrl="/shop/productbrand/findList"
                    entityBeanName="shopBrand"
                    queryEntityUrl="/shop/productbrand/get"
                >
                </GridSelect>
            </el-form-item>
            
            <el-form-item label="商品类型" prop="productType">
                <el-select size="small" style="width: 200px" v-model="shopProduct.productType">
                    <el-option v-for="item of productType" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单类型" prop="orderType" v-if="showStatus">
                <el-select size="small" style="width: 200px" v-model="shopProduct.orderType">
                    <el-option v-for="isShow in orderTypeList" :key="isShow.key" :label="isShow.value" :value="isShow.key"> </el-option>
                </el-select>
            </el-form-item>
<!--			<el-form-item label="人气指数" v-if="shopProduct.productType == 1"  prop="extendField1">-->
<!--			    <el-input style="width: 200px" size="small" v-model="shopProduct.extendField1"></el-input>-->
<!--			</el-form-item>-->
<!--			<el-form-item label="权益价值" v-if="shopProduct.productType == 1"  prop="extendField2">-->
<!--			    <el-input style="width: 200px" size="small" v-model="shopProduct.extendField2"></el-input>-->
<!--			</el-form-item>-->
			<el-form-item label="赠送积分" v-if="shopProduct.productType == 1"  prop="giveScore">
			    <el-input style="width: 200px" size="small" placeholder="购买标准商品赠送" v-model="shopProduct.giveScore"></el-input>
			</el-form-item>
            <el-form-item label="所需积分" v-if="shopProduct.productType == 2"  prop="productScore">
                <el-input style="width: 200px" size="small" placeholder="购买积分商品所需" v-model="shopProduct.productScore"></el-input>
            </el-form-item>
			
			<el-form-item label="商品折扣" v-if="shopProduct.productType == 1"  prop="discount">
			    <el-input style="width: 200px" size="small" placeholder="标准商品折扣" v-model="shopProduct.discount"></el-input>
			</el-form-item>
			<el-form-item label="商品折扣" v-if="shopProduct.productType == 2"  prop="scoreDiscount">
			    <el-input style="width: 200px" size="small" placeholder="积分商品折扣" v-model="shopProduct.scoreDiscount"></el-input>
			</el-form-item>
			
            <el-form-item label="结算价格" v-if="shopProduct.productType == 1"  prop="settlePrice">
                <el-input style="width: 200px" size="small" v-model="shopProduct.settlePrice"></el-input>
            </el-form-item>
			
            <el-form-item label="库存数量" prop="stockSize">
                <el-input style="width: 200px" size="small" v-model="shopProduct.stockSize"></el-input>
            </el-form-item>
            <!-- <el-form-item label="已售数量" prop="saleSize">
                <el-input style="width: 200px" size="small" v-model="shopProduct.saleSize"></el-input>
            </el-form-item> -->
           <el-form-item label="起批数量" prop="buyMinLimit" placeholder="请输入商品的起批数量" v-if="isItWholesale">
                <el-input style="width: 200px" size="small" v-model="shopProduct.buyMinLimit"></el-input>
            </el-form-item>
            <el-form-item label="限购数量" prop="buyLimit">
                <el-input style="width: 200px" size="small" placeholder="请填写限购数量，0不限购" v-model="shopProduct.buyLimit"></el-input>
            </el-form-item>
            <el-form-item label="商品排序" prop="sort">
                <el-input-number
                    style="width: 200px"
                    v-model="shopProduct.sort"
                    size="small"
                    label=""
                    :min="1"
                    :max="100"
                    :step="10"
                    :controls="true"
                    controls-position="both"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="是否精选" prop="isSelected">
                <el-select size="small" style="width: 200px" v-model="shopProduct.isSelected">
                    <el-option v-for="isDelicate in isShowList" :key="isDelicate.key" :label="isDelicate.value" :value="isDelicate.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否优选" prop="isPreferred" v-if="isSa">
                <el-select size="small" style="width: 200px" v-model="shopProduct.isPreferred">
                    <el-option v-for="isDelicate in isShowList" :key="isDelicate.key" :label="isDelicate.value" :value="isDelicate.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品状态" prop="isShow" v-if="showStatus">
                <el-select size="small" style="width: 200px" v-model="shopProduct.isShow">
                    <el-option v-for="isShow in productStatusEnumList" :key="isShow.key" :label="isShow.value" :value="isShow.key"> </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="配送方式" prop="deliverMethod" v-if="showStatus">
                <el-select :disabled="shopProduct.orderType == ''" size="small" style="width: 200px" v-model="shopProduct.deliverMethod">
                    <el-option v-for="isShow in deliverMethodList" :key="isShow.key" :label="isShow.value" :value="isShow.key"> </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="是否包邮" prop="isFreightFree">
                <el-select size="small" style="width: 200px" v-model="shopProduct.isFreightFree" @change="changeIsFreightFree">
                    <el-option
                        v-for="isFreightFree in isShowList"
                        :key="isFreightFree.key"
                        :label="isFreightFree.value"
                        :value="isFreightFree.key"
                    >
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="运费金额" prop="freightPrice" v-if="shopProduct.isFreightFree != 1">
                <el-input style="width: 200px" size="small" v-model="shopProduct.freightPrice"></el-input>
            </el-form-item>

            <el-form-item label="服务类型" prop="serviceType">
                <el-select
                    placeholder='请选择服务费类型'
                    clearable
                    style='width: 200px'
                    size='small'
                    v-model='shopProduct.serviceType'
                >
                    <el-option
                        v-for='(item,index) in serviveTypeList'
                        :key='index'
                        :label='item.value'
                        :value='item.key'
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="isisItASupplyChain"  label="是否供应链" label-width="80px" prop="isSupplier" > 
                  <el-select v-model='shopProduct.isSupplier' placeholder='请选择'   style='width: 200px'>
                    <el-option
                        v-for='(item,index) in isSupplierList'
                        :key='index'
                        :label='item.label'
                        :value='item.value'
                    >
                    </el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item label="服务比例" prop="serviceRatio" v-if="shopProduct.serviceType">-->
<!--                <el-input style='width: 200px;' size="small" v-model="shopProduct.serviceRatio"></el-input>-->
<!--            </el-form-item>-->

            <el-form-item label="商品主图" prop="productPic">
                <el-upload style="width: 200px" class="avatar-uploader" action="" :show-file-list="false" :http-request="uploadAvatar">
                    <img v-if="shopProduct.productPic" :src="shopProduct.productPic" class="avatar" size="small" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import GridSelect from '@/components/gridselect/brand.vue';
import GridSelectShop from '@/components/gridselect/gidselect.vue';
import { get, post, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH, SHOP, SHOP_SEARCH, BRAND, BRAND_SEARCH } from '@/utils/constant.js';

export default {
    components: {
        GridSelect,
        GridSelectShop
    },
    props: { 
        isisItASupplyChain: {
            type: Boolean,
            default: false
        },
        isItWholesale: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            productStatusEnumList: [],//商品状态枚举
            SHOP_code: SHOP,
            SHOP_search: SHOP_SEARCH,
            BRAND_code: BRAND,
            BRAND_search: BRAND_SEARCH,
            isSa: 0,
            saleMode: 1,
            saleModeTwo: '',
            showShop: 0,
            showMode: '',
            showStatus: 0,
            productType:[],
            serviveTypeList:[],
            isSupplierList:[
                 {label: '是', value: 1},
                 {label: '否', value: 0}
            ],
            shopProduct: {
                id: '', //Id
                productName: '', //商品名称
                productNumber: '', //商品货号
                shopId: '',
                shopPrice: '', //本店价格
                supplyPrice: '', //供货价格
                marketPrice: '', //市场价格
                buyLimit: '0',
                productPic: '', //图片
                categoryId: '', //产品分组id
                brandId: '', //品牌Id
                productType: 1,//商品类型
                giveScore:0,//赠送积分
				settlePrice:0,//赠送积分
				extendField1:0,//赠送积分
				extendField2:0,//赠送积分
                productScore:0,//产品所需积分
				discount:1,//标准商品折扣
				scoreDiscount:1,//积分商品折扣
                sort: '10', //排序
                isShow: 1, //是否显示
                stockSize: 999, //库存数量
                saleSize: 0, //产品销量
                serviceType: '',
                serviceRatio: '',
                isFreightFree: 1, //是否免运费 1：是 0：否
                isSelected: 0,//是否精选
                isRecommend:0,// 是否推荐
                isPreferred: 0, // 是否优选
                freightPrice: '', //运费
                category: {},
                orderType: 1,
                costPrice: 0,
				inviterMobile:'',
                isSupply: 0,
                shopCategoryId: '',
                buyMinLimit: '',
                wholesalePrice: '',
                // deliverMethod: '',
                isSupplier:0,//是否供应链
               
            },

            rules: {
                productName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                productNumber: [{ required: true, message: '商品货号不能为空', trigger: 'blur' }],
                shopId: [{ required: true, message: '所属店铺不能为空', trigger: 'blur' }],
                shopPrice: [{ required: true, message: '本店价格不能为空', trigger: 'blur' }],
                supplyPrice: [{ required: true, message: '供货价格不能为空', trigger: 'blur' }],
                marketPrice:[{ required: this.isItWholesale ? true : false , message: '市场价不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '商品类目不能为空', trigger: 'blur' }],
                stockSize:  [{ 
                            required: true, 
                            message: '库存数量不能为空', 
                            trigger: 'blur' 
                        },
                        { 
                            type: 'number',
                            min: 1,
                            max: 999,
                            message: '库存数量必须在1-999之间',
                            trigger: 'blur',
                            transform: (value) => Number(value)
                        }],
                isFreightFree: [{ required: true, message: '是否免运费不能为空', trigger: 'blur' }],
                isSelected: [{ required: true, message: '是否精选不能为空', trigger: 'blur' }],
                isRecommend: [{ required: true, message: '是否推荐不能为空', trigger: 'blur' }],
                isPreferred: [{ required: true, message: '是否优选不能为空', trigger: 'blur' }],
                isShow: [{ required: true, message: '是否上架不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                saleSize: [{ required: true, message: '已售不能为空', trigger: 'blur' }],
                productPic: [{ required: true, message: '缩略图不能为空', trigger: 'blur' }],
                freightPrice: [{ required: true, message: '运费不能为空', trigger: 'blur' }],
                buyLimit: [{ required: true, message: '限购数量不能为空', trigger: 'blur' }],
                giveScore: [{ required: true, message: '赠送积分不能为空', trigger: 'blur'  }],
                productScore: [{ required: true, message: '赠送积分不能为空', trigger: 'blur'  }],
                orderType: [{ required: true, message: '订单类型不能为空', trigger: 'blur' }],
                productType: [{ required: true, message: '商品类型不能为空', trigger: 'blur' }],
                shopCategoryId: [{ required: true, message: '商品分类不能为空', trigger: 'blur' }],
                wholesalePrice: [{ required: true, message: '批发价格不能为空', trigger: 'blur' }],
                buyMinLimit: [{ required: true, message: '起批数量不能为空', trigger: 'blur' }],
                serviceType: [{ required: true, message: '服务费类型不能为空', trigger: 'blur' }],
                serviceRatio: [{ required: true, message: '服务费比列不能为空', trigger: 'blur' }],
                isSupplier: [{ required: true, message: '是否供应链不能为空', trigger: 'blur' }],
                // deliverMethod: [{ required: true, message: '配送方式不能为空', trigger: 'blur' }]
            }, 

            shopProductCategoryList: [],
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
            isShowList: [], //是否上架
            expands: [],
            expandss: [],
            orderTypeList: [],
            shopCategoryIds: [],
            // deliverMethodList1: [],
            // deliverMethodList2: [],
            // deliverMethodList3: [],
            // deliverMethodList4: [],
            // deliverMethodList5: []
        };
    },
    watch: {
        // 监听分类id
        'shopProduct.categoryId': {
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.ClassificationChange();
                }
            },
            immediate: true,
            deep: true
        },

        "shopProduct.serviceType":{
            handler(val){
                for (let i = 0; i < this.serviveTypeList.length; i++) {
                    if(this.serviveTypeList[i].key == val){
                        this.shopProduct.serviceRatio = this.serviveTypeList[i].value
                    }
                }
            }
          },
   
    },
    // computed:{
    //     deliverMethodList(){
    //         if(this.shopProduct.orderType == ''){
    //             return ''
    //         }
    //         return this[`deliverMethodList${this.shopProduct.orderType}`]
    //     }
    // },
    mounted() {
        this.getUser();
        this.getShowShop();
        this.getSaleMode();
        this.getShowStatus();
        this.getClassification();
        this.getIsShowList();
        this.getProductType();
        this.getEnum();
        this.getorderTypeList();
        this.genProductNum();
        // this.getdeliverMethodLists();
        
    },
    methods: {
         changeIsFreightFree(row){
           if(row == 1){
               this.shopProduct.freightPrice = ''
           }
        },
        //是否上架
        getorderTypeList() {
            get(`/mpp/utils/getEnum`, { enumType: `order_type` }).then((res) => {
                if (res.success) {
                    this.orderTypeList = res.enumList;
                }
            });
        },
        getSaleMode(id){
            let obj = {}
            if(id){
                obj.shopId = id
            }
            get('/mall/shop/getSaleMode', obj).then((res)=>{
                if(res.success){
                    if(res.saleMode == 0){
                        this.saleModeTwo = res.saleMode
                        this.saleMode = ''
                    }else{
                        this.saleMode = res.saleMode
                    }
                }
            })
        },
        // getdeliverMethodLists(){
        //     for(let i = 1;i<=5;i++){
        //         get(`/mpp/utils/getEnum`, { enumType: `order_type${i}_deliver_method` }).then((res) => {
        //             if (res.success) {
        //                 console.log(`deliverMethodList${i}`)
        //                 this[`deliverMethodList${i}`] = res.enumList;
        //             }
        //         });
        //     }
        // },
        getIsShowList() {
            get(`/mpp/utils/getEnum`, { enumType: `yes_no` }).then((res) => {
                if (res.success) {
                    this.isShowList = res.enumList;
                }
            });
        },
        getShopId(id){
            let obj = {}
            if(id){
                obj.shopId = id
            }
            get('/shop/shopproductcategory/findAllAsTree',obj).then((res)=>{
                if(res.success){
                    console.log(res.treeData,'res.treeData');
                    this.shopCategoryIds = res.treeData;
                    res.treeData.forEach((element) => {
                        this.expandss.push(element.id);
                    });
                }
            })
        },
        getClassification() {
            get(`/shop/productcategory/findAllAsTree`).then((res) => {
                if (res.success && res.code == 200) {
                    this.shopProductCategoryList = res.treeData;
                    res.treeData.forEach((element) => {
                        this.expands.push(element.id);
                    });
                }
            });
        },
        //生成货号，货号不能为空
        genProductNum() {
            get('/mpp/utils/getProductNo').then((res)=>{
                if(res.success){
                    this.shopProduct.productNumber = res.productNo;
                }
            })
        },
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopProduct.productPic = res.url;
                    console.log(this.shopProduct.productPic);
                }
            });
        },
        validateForm() {
            let flag = true;
            this.$refs.shopProductForm.validate((valid) => {
                if (valid) {
                    flag = true;
                } else {
                    console.log('error submit!!');
                    flag = false;
                }
            });
            return flag;
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        ClassificationChange() {
            let obj = {
                categoryId: this.shopProduct.categoryId,
                brandId: this.shopProduct.brandId
            };

            eventBus.$emit('attribute', obj);
            eventBus.$emit('speci', obj);
        },
        getValueShopId(value){
            this.shopProduct.shopId = value;
            this.shopProduct.shopCategoryId = ""
            this.getSaleMode(value)
            this.getShopId(value)
        },
        getValue(value) {
            this.shopProductCategoryList.brandId = value;
            this.shopProduct.brandId = value;
            this.ClassificationChange();
        },
        getProductType(){
            get("/mpp/utils/getEnum",{enumType:"product_type"}).then((res)=>{
                if(res.success && res.code == 200){
                    this.productType = res.enumList
                    console.log('this.productType',this.productType);
                }
            })
        },
        // 计算商品状态
        computeProductStatus(type){
            for (let i = 0; i < this.productStatusEnumList.length; i++) {
                if(this.productStatusEnumList[i].key == type){
                    return this.productStatusEnumList[i].value
                }
            }
        },

        // 获取showShop
        getShowShop(){
            get('/mall/shop/getShowShop').then((res)=>{
                if(res.success){
                    this.showShop = res.showShop
                    if(this.showShop == 0){
                        this.getShopId()
                        get('/mpp/utils/getShopMode').then((res)=>{
                            if(res.success){
                                this.showMode = res.shopMode
                            }
                        })
                    }
                }
            })
        },
        //获取showStatus
        getShowStatus(){
            get('/shop/product/getShowStatus').then((res)=>{
                if(res.success){
                    this.showStatus = res.showStatus
                }
            })
        },
        //设置从第三方获取的商品信息
        settingGrabInfo(value){
            this.shopProduct.productName = value.productName
            this.shopProduct.productPic = value.productPic
        },
        // 获取用户信息
        getUser(){
            get("/mpp/user/getUserCache").then((res) => {
                if(res.user){
                    this.isSa = res.user.isSa
                }
            })
        },
        getEnum(){
            get('/mpp/utils/getEnum',{
                enumType:'product_status',
            }).then((res)=>{
                if(res.success){
                    this.productStatusEnumList = res.enumList
                }
            })

            get('/shop/utils/getEnum', { enumType: 'store_service_type' }).then((res) => {
                if (res.success && res.code == 200) {
                    this.serviveTypeList = res.enumList;
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
.avatarWide {
    width: 200px;
    height: 120px;
}
</style>
